import React, { useMemo, useState } from "react";
import {
  flexRender,
  useReactTable,
  getCoreRowModel,
  ColumnDef,
} from "@tanstack/react-table";
import {
  Button,
  Menu,
  MenuItem,
  Popover,
  TBody,
  TD,
  TH,
  THead,
  TR,
  Table,
  Variants,
} from "@sede-enterprise/shell-ds-react-framework";
import { Link } from "react-router-dom";
import { AnchorSpan } from "../styledComponent/StyledComponent";
import { formatDateToDDMMMYYYY } from "../../services/UtilService";
import { Ellipsis } from "@sede-enterprise/shell-ds-react-framework/build/esm/components/Icon/components";
import TransactionActionModal from "../TransactionActionModal/TransactionActionModal";
import { postDataFile } from "../../services/ApiService";
import { ApiUrls } from "../../helpers/ApiUrls";
import ResponseErrorModal from "../responseErrorModal/ResponseErrorModal";
import { useToast } from "rc-toastr";
import { APIErrorResponseInterface } from "../../helpers/InterfacesConstants";
type TransactionHistory = {
  // id: number;
  ticket: string;
  batchNumber: string;
  receivedDate: string;
  ticketDate: string;
  country: string;
  site: string;
  customer: string;
  customerCode: string;
  transactionType: string;
  businessStatus: string;
  isErrored: boolean;
  headerId: string;
  transactionStatus: string;
  menuItems: string[];
};

const RawdataTable = (props: {
  data: TransactionHistory[];
  refreshPage: () => void;
}) => {
  const data = props.data;
  const { toast } = useToast();
  const [openTransactionModal, setOpenTransactionModal] = useState(false);
  const [openReverseTransactionModal, setOpenReverseTransactionModal] =
    useState(false);
  const [apiErrorResponse, setApiErrorResponse] =
    useState<APIErrorResponseInterface | null>();

  const [modalAction, setModalAction] = useState<"Cancel" | "MI">("Cancel");

  const [transactionDetails, setTransactionDetails] = useState<{
    transactionId: string;
    ticket: string;
    reason: string;
  }>({
    transactionId: "",
    ticket: "",
    reason: "",
  });

  const getColor = (transactionStatus: string) => {
    let colorCode = "";
    switch (transactionStatus.trim()) {
      case "Distributed":
        colorCode = "#008557";
        break;
      case "MI Error":
        colorCode = "#B25F00";
        break;
      case "Error":
        colorCode = "#DD1D21";
        break;
      case "Obsolete":
        colorCode = "#757575";
        break;
      default:
        colorCode = "";
        break;
    }
    return colorCode;
  };

  const columns = useMemo<ColumnDef<TransactionHistory>[]>(
    () => [
      {
        accessorFn: (row) => row.ticket,
        header: "Ticket#",
        cell: ({ row }) => {
          const { ticket, headerId } = row.original;
          return (
            <Link to={"/rawdata/" + headerId}>
              <AnchorSpan>{ticket}</AnchorSpan>
            </Link>
          );
        },
        id: "ticket",
        size: 60,
      },
      {
        accessorKey: "headerId",
        header: "Delivery ID",
        id: "headerId",
        cell: (info) => info.getValue(),
        size: 60,
      },
      {
        accessorFn: (row) => row.batchNumber,
        header: "Batch#",
        cell: (info) => info.getValue(),
        id: "batch",
        size: 60,
      },
      {
        accessorFn: (row) => row.receivedDate,
        cell: (info) => formatDateToDDMMMYYYY(String(info.getValue())),
        header: "Received Date",
        id: "receivedDate",
        size: 60,
      },
      {
        accessorFn: (row) => row.ticketDate,
        cell: (info) => formatDateToDDMMMYYYY(String(info.getValue())),
        header: "Transaction Date",
        id: "ticketDate",
        size: 60,
      },
      {
        accessorFn: (row) => row.country,
        id: "country",
        cell: (info) => info.getValue(),
        header: "Country",
        size: 60,
      },
      {
        accessorKey: "site",
        header: "Site",
        id: "site",
        cell: (info) => info.getValue(),
        size: 60,
      },
      {
        accessorKey: "customer",
        header: "Customer",
        id: "customer",
        cell: (info) => info.getValue(),
        size: 60,
      },
      {
        accessorKey: "customerCode",
        header: "Cus Code",
        id: "customerCode",
        cell: (info) => info.getValue(),
        size: 60,
      },
      {
        accessorKey: "paymentType",
        header: "Credit Type",
        id: "paymentType",
        cell: (info) => info.getValue(),
        size: 60,
      },
      {
        accessorKey: "transactionType",
        header: "Tran Type",
        id: "transactionType",
        cell: (info) => info.getValue(),
        size: 60,
      },
      {
        accessorFn: (row) => row.transactionStatus,
        header: "Operational Status",
        id: "transactionStatus",
        cell: ({ row }) => {
          const { transactionStatus } = row.original;
          return (
            <span
              style={{
                color: getColor(transactionStatus),
              }}
            >
              {transactionStatus}
            </span>
          );
        },
        size: 60,
      },
      {
        accessorFn: (row) => row.ticket,
        header: "Actions",
        id: "edit",
        cell: ({ row }) => {
          const { ticket, headerId, menuItems } = row.original;
          return (
            <Popover
              popup={
                <Menu style={{ width: "150px" }}>
                  {menuItems.indexOf("View") != -1 && (
                    <Link to={"/rawdata/" + headerId}>
                      <MenuItem
                        key="1"
                        style={{ fontWeight: "650", paddingLeft: "16px" }}
                      >
                        View
                      </MenuItem>
                    </Link>
                  )}
                  {menuItems.indexOf("Edit") != -1 && (
                    <Link to={"/update/" + headerId}>
                      <MenuItem
                        key="2"
                        style={{ fontWeight: "650", paddingLeft: "16px" }}
                      >
                        Edit
                      </MenuItem>
                    </Link>
                  )}
                  {menuItems.indexOf("Cancel") != -1 && (
                    <MenuItem
                      key="3"
                      onClick={() =>
                        openCancelModal("Cancel", headerId, ticket)
                      }
                      style={{ fontWeight: "650" }}
                    >
                      Cancel
                    </MenuItem>
                  )}
                  {menuItems.indexOf("MI") != -1 && (
                    <MenuItem
                      key="6"
                      onClick={() => openCancelModal("MI", headerId, ticket)}
                      style={{ fontWeight: "650" }}
                    >
                      Mark as MI
                    </MenuItem>
                  )}
                  {menuItems.indexOf("Reverse") != -1 && (
                    <MenuItem
                      key="4"
                      onClick={() =>
                        openReverseModal("Cancel", headerId, ticket)
                      }
                      style={{ fontWeight: "650" }}
                    >
                      Reverse
                    </MenuItem>
                  )}
                  {menuItems.indexOf("Correction") != -1 && (
                    <Link to={"/correct/" + headerId}>
                      <MenuItem
                        key="5"
                        style={{ fontWeight: "650", paddingLeft: "16px" }}
                      >
                        Correction
                      </MenuItem>
                    </Link>
                  )}
                </Menu>
              }
            >
              <Button
                variant={Variants.Transparent}
                icon={<Ellipsis />}
                style={{
                  float: "right",
                  justifyContent: "end",
                  minWidth: "35px",
                }}
                aria-label="Row Menu Ellipsis icon"
              ></Button>
            </Popover>
          );
        },
        size: 60,
      },
    ],
    []
  );

  const openCancelModal = (
    strAction: string,
    headerId: string,
    ticket: string
  ) => {
    setTransactionDetails({
      transactionId: headerId,
      ticket: ticket,
      reason: "",
    });
    setModalAction(strAction === "Cancel" ? "Cancel" : "MI");
    setOpenTransactionModal(true);
  };

  const openReverseModal = (str: string, headerId: string, ticket: string) => {
    setTransactionDetails({
      transactionId: headerId,
      ticket: ticket,
      reason: "",
    });
    setOpenReverseTransactionModal(true);
  };

  const table = useReactTable({
    data,
    columns,
    getCoreRowModel: getCoreRowModel(),
  });

  const getActionData = (action: "Cancel" | "MI") => {
    if (action === "Cancel") {
      return {
        url: ApiUrls.cancelTransaction,
        actionText: "Cancelled",
        modalTitle: "Cancel Transaction",
      };
    }

    return {
      url: ApiUrls.MiTransaction,
      actionText: "Marked as MI",
      modalTitle: "Mark as MI Transaction",
    };
  };

  const handleTransactionAction = (data: any) => {
    const actionData = getActionData(modalAction);
    const url = actionData.url + transactionDetails.transactionId;
    postDataFile(url, data)
      .then((response) => {
        setOpenTransactionModal(false);
        toast.success(
          `Transaction ${transactionDetails.ticket} ${actionData.actionText} successfully`
        );
        props.refreshPage();
      })
      .catch((error) => {
        setOpenTransactionModal(false);
        setApiErrorResponse({
          message: error.response.data.message,
          traceId: error.response.data.traceId,
        });
      });
  };

  const reverseTransaction = (data: any) => {
    const url = ApiUrls.reverseTransaction + transactionDetails.transactionId;
    postDataFile(url, data)
      .then((response) => {
        setOpenReverseTransactionModal(false);
        toast.success(
          "Transaction " +
            transactionDetails.transactionId +
            " Reversed Successfully"
        );
        props.refreshPage();
      })
      .catch((error) => {
        setOpenReverseTransactionModal(false);
        setApiErrorResponse({
          message: error.response.data.message,
          traceId: error.response.data.traceId,
        });
      });
  };

  return (
    <>
      <Table size="small" align="left" width="100%">
        <THead>
          {table.getHeaderGroups().map((headerGroup) => (
            <TR key={headerGroup.id}>
              {headerGroup.headers.map((header) => (
                <TH key={header.id} colSpan={header.colSpan}>
                  {header.isPlaceholder
                    ? null
                    : flexRender(
                        header.column.columnDef.header,
                        header.getContext()
                      )}
                </TH>
              ))}
            </TR>
          ))}
        </THead>
        <TBody>
          {table.getRowModel().rows.map((row) => (
            <TR key={row.id}>
              {row.getVisibleCells().map((cell) => (
                <TD key={cell.id}>
                  {flexRender(cell.column.columnDef.cell, cell.getContext())}
                </TD>
              ))}
            </TR>
          ))}
        </TBody>
      </Table>

      <TransactionActionModal
        open={openTransactionModal}
        onClose={() => setOpenTransactionModal(false)}
        title={getActionData(modalAction).modalTitle}
        description={transactionDetails?.ticket}
        onSubmit={handleTransactionAction}
        action={modalAction}
      />

      {/* TransactionActionModal for Reverse Transaction */}
      <TransactionActionModal
        open={openReverseTransactionModal}
        data={transactionDetails}
        onClose={() => {
          setOpenReverseTransactionModal(false);
        }}
        title="Reverse Transaction"
        description={transactionDetails.ticket}
        onSubmit={reverseTransaction}
      />
      <ResponseErrorModal
        errorDetails={apiErrorResponse}
        isOpen={apiErrorResponse ? true : false}
        onModalClose={() => {
          setApiErrorResponse(null);
        }}
      ></ResponseErrorModal>
    </>
  );
};

export default RawdataTable;
